import React from "react";
import * as S from "./AlertsStyle";

const Alerts = (props) => {
  return (
    <S.BootstrapContainer>
      <S.BootstrapAlert
        color="danger"
        isOpen={props.showAlert}
        toggle={props.onAlertDismiss}
      >
        {props.errorMessage}
      </S.BootstrapAlert>

      <S.BootstrapAlert
        color="success"
        isOpen={props.showSuccessAlert}
        toggle={props.onAlertDismiss}
      >
        {props.successMessage}
      </S.BootstrapAlert>
    </S.BootstrapContainer>
  );
};

export default Alerts;
